export const PAYMENT_METHOD_CASH = 1
export const PAYMENT_METHOD_ONLINE = 2
export const PAYMENT_METHOD_TERMINAL = 3
